import { IOdataField } from './IOdataField';

export class OdataFieldDateOnly implements IOdataField {
  private value: Date;

  constructor(value: Date) {
    this.value = value;
  }

  toFieldString() {
    return `${this.value.getUTCFullYear()}-${("00" + (this.value.getUTCMonth() + 1)).slice(-2)}-${("00" + this.value.getUTCDate()).slice(-2)}`;
  };
}
